module.exports = __webpack_public_path__ + "img/FITfactory-StudioM.f9d79341.jpg";